(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/mobile/components/mobile-footer.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/mobile/components/mobile-footer.js');
'use strict';

const {
  ReactInfoButtonText
} = svs.tb_ui;
const {
  showMobileUseInformation
} = svs.myProfile.react.pages.myInformation.myInformation.mobile.MobileDialogs;
const handleShowMobileUseInfo = e => {
  e.preventDefault();
  showMobileUseInformation();
};

const MobileFooter = () => React.createElement(React.Fragment, null, React.createElement(ReactInfoButtonText, {
  onClick: handleShowMobileUseInfo,
  text: "Hur anv\xE4nder vi ditt mobilnummer?"
}), React.createElement("p", {
  className: "margin-top-1"
}, React.createElement("a", {
  className: "u-text-decoration-underline",
  href: svs.core.urlMapping.get('termsIntegrityPersonData')
}, "L\xE4s mer"), ' ', "om hur AB Svenska Spel hanterar dina personuppgifter."));
svs.myProfile.react.pages.myInformation.myInformation.mobile.MobileFooter = MobileFooter;

 })(window);